import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PapperBlock from '../../../components/PapperBlock';
import SEOForm from '../SEOForm';
import { getSeoOffersById, updateSeoOffersById } from '../requests';
import { SEOIcon } from '../../../constants/icons';

export default function UpdateSeoOffers() {
  const [data, setData] = useState({});
  const [loaded, setLoaded] = useState(false);
  const params = useParams();
  const { id } = params;
  async function processingRequest() {
    setData((await getSeoOffersById(id)).data);
    setLoaded(true);
  }
  useEffect(() => {
    processingRequest();
  }, [loaded]);

  return (
    <PapperBlock title="Обновить SEO акции" icon={<SEOIcon />}>
      {loaded && (
        <SEOForm submitHandler={updateSeoOffersById} data={data} submitButton />
      )}
    </PapperBlock>
  );
}
